export const HOME_BASE_LOCATION_NAMES = [
  'home base',
];

const normalizeLocationName = (location) => String(location || '').trim().toLowerCase();

const getHiddenLocationNames = (hiddenLocations = []) =>
  new Set(hiddenLocations.map(normalizeLocationName));

export const isVisibleLocation = (location, hiddenLocations) =>
  !getHiddenLocationNames(hiddenLocations).has(normalizeLocationName(location));

export const getVisibleLocations = (locations = [], hiddenLocations = []) =>
  locations.filter((location) => isVisibleLocation(location, hiddenLocations));

export const getSortedVisibleLocations = (locations = [], hiddenLocations = []) =>
  getVisibleLocations(locations, hiddenLocations).sort((a, b) => a.localeCompare(b));

export const getVisibleLocationOrDefault = (location, visibleLocations) =>
  visibleLocations.includes(location) ? location : visibleLocations[0] || '';
